import { EmailNotificationHistory } from './email-notification-history';
import { EmailNotificationDocument } from './email-notification-document';

export class Email {
  id: string;
  from: string;
  to: Array<string> = [];
  cc: Array<string> = [];
  bcc: Array<string> = [];
  originalFrom: string;
  originalTo: Array<string> = [];
  originalCc: Array<string> = [];
  originalBcc: Array<string> = [];
  repliesTo: Array<string> = [];
  document: Array<EmailNotificationDocument> = [];
  sent: Date;
  subject: string;
  template: string;
  body: string;
  emailAttachments: Array<string> = [];
  emailNotificationHistories: Array<EmailNotificationHistory> = [];
  skipSending: boolean = false;
}
